import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6352d9da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-layout" }
const _hoisted_2 = { class: "oxd-layout-navigation" }
const _hoisted_3 = { class: "oxd-layout-context" }
const _hoisted_4 = { class: "oxd-layout-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_side_panel = _resolveComponent("oxd-side-panel")!
  const _component_oxd_top_bar = _resolveComponent("oxd-top-bar")!
  const _component_oxd_overlay = _resolveComponent("oxd-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oxd_side_panel, {
        onCollapse: _ctx.onCollapse,
        toggle: _ctx.collapse,
        "menu-items": _ctx.sidepanelMenuItems,
        "brand-logo-src": _ctx.brandLogoSrc,
        "brand-banner-src": _ctx.brandBannerSrc,
        "home-url": _ctx.homeUrl
      }, null, 8, ["onCollapse", "toggle", "menu-items", "brand-logo-src", "brand-banner-src", "home-url"]),
      _createVNode(_component_oxd_top_bar, {
        onCollapse: _ctx.onCollapse,
        toggle: _ctx.collapse,
        "menu-items": _ctx.topbarMenuItems,
        user: _ctx.user,
        breadcrumb: _ctx.breadcrumb
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "user-actions", {}, undefined, true)
        ]),
        _: 3
      }, 8, ["onCollapse", "toggle", "menu-items", "user", "breadcrumb"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.containerClasses)
    }, [
      _createVNode(_component_oxd_overlay, {
        onClick: _ctx.onCollapse,
        class: "oxd-layout-overlay",
        show: _ctx.collapse
      }, null, 8, ["onClick", "show"]),
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
      ])
    ], 2)
  ]))
}